
export default function hexToArray(color, opacity) {
    
    let hex = color.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    if (hex.length !== 6) {
        throw new Error('Invalid hex color. Use 3 or 6 digits, optionally with #.');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const a = (opacity !== undefined && !isNaN(opacity)) ? parseFloat(opacity) : 1;

    return [r, g, b, a];
}